var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.2138 18.7876L14.7322 12.2537C15.0176 11.967 15.0176 11.5025 14.7322 11.215C14.4468 10.9283 13.9833 10.9283 13.6979 11.215L7.69665 17.2307L1.69542 11.2158C1.41002 10.929 0.946458 10.929 0.660338 11.2158C0.374941 11.5025 0.374941 11.9677 0.660338 12.2544L7.17878 18.7883C7.46123 19.0707 7.93207 19.0707 8.2138 18.7876Z","fill":"#6C6C6C","key":0}),React.createElement("path",{"d":"M7.17878 0.212404L0.660337 6.74633C0.37494 7.03304 0.37494 7.49754 0.660337 7.78497C0.945735 8.07168 1.40929 8.07168 1.69469 7.78497L7.69593 1.76931L13.6972 7.78425C13.9826 8.07095 14.4461 8.07095 14.7322 7.78425C15.0176 7.49754 15.0176 7.03231 14.7322 6.74561L8.2138 0.21168C7.93135 -0.0706804 7.4605 -0.0706805 7.17878 0.212404Z","fill":"#6C6C6C","key":1})]);
}

Expand.defaultProps = {"width":"15","height":"19","viewBox":"0 0 15 19","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
